import { useEffect, useState } from 'react'
import useHasMounted from 'utils/useHasMounted'

function useOSType(): string {
  const isMounted = useHasMounted()
  const [osType, setOsType] = useState('windows')

  useEffect(() => {
    if (isMounted) {
      switch (location.pathname) {
        case '/features/windows/':
          setOsType('windows')
          break
        case '/features/macos/':
          setOsType('macos')
          break
        case '/features/linux/':
          setOsType('linux')
          break
        default:
          setOsType('windows')
      }
    }
  }, [isMounted])

  return osType
}

export default useOSType
